import { useEffect, useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useHttpClient } from '../../../shared/http-client';
import { Table } from "../../../elements/table";
import { RouteComparisonModal } from '../customers/tabs/route-comparison-modal';
import { PageBody } from '../../../elements/page-body';
import { SearchIcon } from '@heroicons/react/outline';
import { Button } from '../../../elements/button';

//import { ItvTabForm } from './itv-tab-form';




export const RutasRealizadas = ({
    item,
    onAction = () => { }
}: {
    item?: any;
    onAction?: () => void;
}) => {
    const { open, close } = useDrawer();
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);
    const [refresh, setRefresh] = useState<string | null>(null);
    const [showRouteModal, setShowRouteModal] = useState<boolean>(false);
    const [routeData, setRouteData] = useState<any | null>(null);
    
    // Filter states
    const [customerNameDraft, setCustomerNameDraft] = useState('');
    const [customerNameFilter, setCustomerNameFilter] = useState('');
    const [commercialFilter, setCommercialFilter] = useState<string>('');
    const [dateFromFilter, setDateFromFilter] = useState<string>('');
    const [dateToFilter, setDateToFilter] = useState<string>('');
    const [drivers, setDrivers] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);

    // Load drivers and customers for filters
    useEffect(() => {
        api('/fleet/drivers/?is_commercial=true', 'GET');
        api('/fleet/customers/', 'GET');
    }, []);


    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };

    const handleViewRoutes = (visit: any) => {
        console.log('visit', visit)
        // Formatear la fecha a YYYY-MM-DD
        const date = new Date(visit.timestamp);
        const formattedDate = date.toISOString().split('T')[0];
        //const formattedDate = '2026-01-02';

        api(`/fleet/sales-rep-route-comparisons/?driver=${visit.driver.id}&date=${formattedDate}`, 'GET');
    };


    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('fleet/customer-visits')) {
                if (state.method === 'GET') {
                    setData(state.data)
                }
            }
            if (state.path.includes('sales-rep-route-comparisons')) {
                if (state.method === 'GET') {
                    console.log('sales-rep-route-comparisons', state.data)
                    setRouteData(state.data);
                    setShowRouteModal(true);
                }
            }
            if (state.path.includes('/fleet/drivers/') && state.method === 'GET') {
                setDrivers(state.data.results || []);
            }
            if (state.path.includes('/fleet/customers/') && state.method === 'GET') {
                setCustomers(state.data.results || []);
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }
        }
    }, [state]);

    const handleApplyFilters = () => {
        const trimmedName = customerNameDraft.trim();
        setCustomerNameFilter(trimmedName);
        setRefresh(Date.now().toString());
    };

    const handleResetFilters = () => {
        setCustomerNameDraft('');
        setCustomerNameFilter('');
        setCommercialFilter('');
        setDateFromFilter('');
        setDateToFilter('');
        setRefresh(Date.now().toString());
    };

    // Build query string for filters
    const buildQueryString = () => {
        const params: string[] = [];
        if (customerNameFilter) params.push(`customer_name=${customerNameFilter}`);
        if (commercialFilter) params.push(`driver=${commercialFilter}`);
        if (dateFromFilter) params.push(`date_from=${dateFromFilter}`);
        if (dateToFilter) params.push(`date_to=${dateToFilter}`);
        return params.join('&');
    };



    return (
        <PageBody
            title={'common.label.rutas-realizadas'}
        >
            <>
                {showRouteModal && routeData && (
                    <RouteComparisonModal
                        actualRoutes={routeData.actual_routes || []}
                        plannedRoutes={routeData.planned_routes || []}
                        onClose={() => setShowRouteModal(false)}
                    />
                )}

                <div className="w-full pb-3">
                    <div className="w-full flex flex-col gap-3">
                        <div className="flex flex-col sm:flex-row gap-3">
                            <div className="w-full sm:max-w-md">
                                <label className="block text-xs font-semibold text-[#000] mb-1">
                                    {t('common.form-label.cliente')}
                                </label>
                                <div className="relative">
                                    <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                        <SearchIcon className="h-4 w-4 text-[#006bc6]" />
                                    </span>
                                    <input
                                        type="search"
                                        name="customer"
                                        value={customerNameDraft}
                                        onChange={(e) => setCustomerNameDraft(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleApplyFilters();
                                            }
                                        }}
                                        placeholder={t('common.form-label.cliente')}
                                        className="block w-full h-[40px] rounded-md border border-[#ccc] bg-white pl-9 pr-3 text-sm text-gray-900 outline-none focus:border-[#006bc6] focus:ring-2 focus:ring-[#006bc6]/20"
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:max-w-md">
                                <label className="block text-sm font-semibold text-gray-700 mb-1">
                                    {t('common.label.comercial')}
                                </label>
                                <select
                                    value={commercialFilter}
                                    onChange={(e) => setCommercialFilter(e.target.value)}
                                    className="w-full h-[40px] px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#006bc6] focus:border-transparent"
                                >
                                    <option value="">{t('common.label.todos')}</option>
                                    {drivers.map((driver: any) => (
                                        <option key={driver.id} value={driver.id}>
                                            {driver.full_name || driver.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="w-full sm:max-w-md">
                                <label className="block text-sm font-semibold text-gray-700 mb-1">
                                    {t('transaction_time_after')}
                                </label>
                                <input
                                    type="date"
                                    value={dateFromFilter}
                                    onChange={(e) => setDateFromFilter(e.target.value)}
                                    className="w-full h-[40px] px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#006bc6] focus:border-transparent"
                                />
                            </div>
                            <div className="w-full sm:max-w-md">
                                <label className="block text-sm font-semibold text-gray-700 mb-1">
                                    {t('transaction_time_before')}
                                </label>
                                <input
                                    type="date"
                                    value={dateToFilter}
                                    onChange={(e) => setDateToFilter(e.target.value)}
                                    className="w-full h-[40px] px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#006bc6] focus:border-transparent"
                                />
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <Button
                                onClick={handleApplyFilters}
                                label="common.filter.title"
                                variant="primary"
                            />
                            <Button
                                onClick={handleResetFilters}
                                label="Reset"
                                variant="gray"
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <Table
                        path="/fleet/customer-visits/"
                        deletePath="/fleet/customer-visits/"
                        callBeforeDrawerClosed={handleClose}
                        noEdit={true}
                        noDelete={true}
                        withPagination
                        refresh={refresh}
                        query={buildQueryString()}
                        customActions={(visit: any) => (
                            <>
                                <button
                                    className="px-2 rounded-md text-primary text-xs"
                                    onClick={() => handleViewRoutes(visit)}
                                >
                                    {t('common.button.ver-rutas')}
                                </button>
                            </>
                        )}
                        headers={[
                            {
                                key: 'timestamp',
                                type: 'date',
                                label: 'common.labels.date',
                            },
                            /*  {
                                 key: 'areas',
                                 label: 'common.label.areas'
                             }, */
                            {
                                key: 'contact_person',
                                label: 'common.form-label.persona-contacto',
                            },
                            {
                                key: 'cargo',
                                label: 'common.label.cargo',
                            },
                            {
                                key: 'email',
                                label: 'Email',
                            },
                            {
                                key: 'driver',
                                subKey: 'full_name',
                                label: 'common.label.comercial',
                            },
                            {
                                key: 'customer',
                                subKey: 'name',
                                label: 'common.form-label.cliente',
                            },

                        ]}
                    />

                </div>


            </>
        </PageBody>
    );
};